module.exports = __webpack_public_path__ + "h5/img/logo2.b14365b3.png";